import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const fetchSuppliers = async () => {
    const suppliers = await apiInputService.get("/Supplier")
    const { data } = suppliers;

    return data;
}


export const useSuppliersQuery = (subscription: string, options?: any) => {
    return useQuery<any[]>(["suppliers", subscription], () => fetchSuppliers(), {
        ...options,
        
        staleTime: Infinity,
    });
}